import {Component, HostBinding, OnInit} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-loader',
  templateUrl: 'loadar.component.html',
})
export class LoaderComponent implements OnInit {
  public showLoader;

  constructor(private localSt: LocalStorageService) {}

  ngOnInit() {
    this.localSt.observe('loaderSetting').subscribe((data) => {
      this.showLoader = data.showLoader;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/loader/loadar.component.ts